// lot store inner constants

export const GET_ISSHOWMSG = 'getIsShowMessages';
export const GET_ACCESSTOKEN = 'getAccessToken';
export const GET_SIGNALRCONNECTED = 'getIsSignalRConnected';
export const GET_UNREGUSERTOKEN = 'getUnregisteredUserToken';
export const GET_SIGNLIBFILESSERVERVERSION = 'getSignLibFilesServerVersion';

export const MUT_ISSHOWMSG = 'setIsShowMessages';
export const MUT_ACCESSTOKEN = 'setAccessToken';
export const MUT_SIGNALRCONNECTED = 'setIsSignalRConnected';
export const MUT_UNREGUSERTOKEN = 'setUnregisteredUserToken';
export const MUT_SIGNLIBFILESSERVERVERSION = 'setSignLibFilesServerVersion';
